import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  align-self: flex-end;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: ${theme.spacing(2, 0)};
`;

export const textStyle = css`
  font-style: italic;
  color: ${theme.colorsV2.neutral70()};
  margin-left: ${theme.spacing(1)};
  margin-right: ${theme.spacing(0.25)};
`;

export const feedbackButtonLoadingStyle = (isLoading: boolean) => {
  // When the button is in loading state, we want to fix its width to prevent layout shift.
  return css({ ...(isLoading && { padding: 0, width: '34px' }) });
};
